import { render, staticRenderFns } from "./ModalRegistCard.vue?vue&type=template&id=657c80a2&scoped=true&"
import script from "./ModalRegistCard.vue?vue&type=script&lang=js&"
export * from "./ModalRegistCard.vue?vue&type=script&lang=js&"
import style0 from "./ModalRegistCard.vue?vue&type=style&index=0&id=657c80a2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "657c80a2",
  null
  
)

export default component.exports